import { ICollapsibleFiltersConfig } from '..';
import ActionButtons from './ActionButtons';
import CollapseArea from './CollapseArea';
import FilterContainer from './FilterContainer';
import FilterWrapper from './FilterWrapper';

interface ICollapseSomeFilterViewProps {
  isCollapse?: boolean;
  requiredFilters: React.ReactNode[];
  collapsibleFilters: React.ReactNode[];
  config?: ICollapsibleFiltersConfig;
}

const CollapseSomeFilterView = (props: ICollapseSomeFilterViewProps) => {
  const { isCollapse, requiredFilters, collapsibleFilters, config } = props;

  return (
    <FilterWrapper>
      <FilterContainer config={config}>{requiredFilters}</FilterContainer>

      <CollapseArea isCollapse={isCollapse}>
        <FilterContainer config={config}>{collapsibleFilters}</FilterContainer>
      </CollapseArea>

    </FilterWrapper>
  );
};

export default CollapseSomeFilterView;
